<template>
    <input
        type="file"
        :accept="audioFileAllowedExtensions.join(',')"
        @change.prevent="onChange"
    >
</template>
<script>
import { audioFileAllowedExtensions } from '@/utils/config/episodeOptions';

export default {
    data: () => ({
        audioFileAllowedExtensions,
    }),

    methods: {
        /**
         * Handles change event on input.
         *
         * @param  {Event} event Change event.
         */
        onChange(event) {
            this.$emit('change', event.target.files[0]);
        },
    },
};
</script>
